import { render, staticRenderFns } from "./RemoveProposalProducts.vue?vue&type=template&id=46e5d694&"
import script from "./RemoveProposalProducts.vue?vue&type=script&lang=js&"
export * from "./RemoveProposalProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports